import { Component, OnInit } from '@angular/core';
import { PortalDashboardGroup } from '../../../entities/portalDashboardGroup';
import { PortalDashboardGroupService } from '../../../services/portalDashboardGroup.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { portalSlug } from '../../../utils/portal-slug';

@Component({
    selector: 'ntr-portal-dashboard-group-edit',
    templateUrl: './portal-dashboard-group-edit.component.html',
    standalone: false
})
export class PortalDashboardGroupEditComponent implements OnInit {
  group: PortalDashboardGroup = new PortalDashboardGroup();
  submitted = false;
  error = '';

  constructor(private groupService: PortalDashboardGroupService, private router: Router, private route: ActivatedRoute) {}

  onSubmit() {
    this.submitted = true;
    this.error = '';
    this.groupService.add(this.group)
      .subscribe(
        () => {
          this.router.navigateByUrl('/portal-dashboard-group');
        },
        err => {
          this.submitted = false;
          this.error = err?.error?.message || 'Failed to save the group. Please try again.';
        }
      );
  }

  goToList() {
    this.router.navigateByUrl('/portal-dashboard-group');
  }

  /** What key this will get. Existing groups keep theirs — the key is immutable. */
  keyPreview(): string {
    return this.group.key ? this.group.key : portalSlug(this.group.label || '');
  }

  /**
   * Whether the heading should identify an existing group by name rather than
   * show the generic "Add group" title. A group can already have an id (e.g.
   * loaded from the route) but no label yet if it hasn't finished loading —
   * that case still falls back to "Add group" rather than rendering an empty
   * `Group ""`.
   */
  get isEditingExistingGroup(): boolean {
    return !!(this.group?.id && this.group?.label);
  }

  ngOnInit(): void {
    this.group = new PortalDashboardGroup();
    this.route.paramMap.pipe(
      switchMap((params: ParamMap) => this.groupService.get(params.get('id'))))
      .subscribe(group => {
        if (group !== null) {
          this.group = group;
        }
      });
  }
}
